module.exports = __webpack_public_path__ + "img/connection-left-2.8e4a6657.png";